<template>
	<v-container v-if="list.productGroups.length > 0">
		<v-scrollable
			class="flex snap-x scroll-px-sm flex-nowrap space-x-xs px-sm md:scroll-px-0 md:space-x-sm md:px-0"
		>
			<template #header="{move}">
				<v-scrollable-header
					title-tag="h2"
					:title="list.label || t('product-nosto-title')"
					class="mx-sm md:mx-0"
					@move="move"
				/>
			</template>

			<v-scrollable-item
				v-for="product in products"
				:key="product.key"
				class="w-40 shrink-0 snap-start md:w-65"
			>
				<v-elevate-listing-product-card :product="product" />
			</v-scrollable-item>
		</v-scrollable>
	</v-container>
</template>

<script lang="ts" setup>
import type {ProductPage} from "@apptus/esales-api";

const properties = defineProps<{
	list: ProductPage["recommendationLists"][0];
}>();

const {t} = useI18n();

const products = computed(() =>
	properties.list.productGroups.flatMap((group) => group.products),
);
</script>

<i18n lang="json">
{
	"et": {
		"product-nosto-title": "Kas otsite midagi paremat?"
	},
	"fi": {
		"product-nosto-title": "Etsitkö jotain parempaa?"
	}
}
</i18n>
